/* import __COLOCATED_TEMPLATE__ from './detail-learners-and-learner-groups.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { hash } from 'rsvp';
import { uniqueValues } from 'ilios-common/utils/array-helpers';
import { TrackedAsyncData } from 'ember-async-data';
let DetailLearnersAndLearnerGroupsComponent = (_class = class DetailLearnersAndLearnerGroupsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "isManaging", _descriptor2, this);
    _initializerDefineProperty(this, "learnerGroupBuffer", _descriptor3, this);
    _initializerDefineProperty(this, "learnerBuffer", _descriptor4, this);
    _defineProperty(this, "manage", _buildTask(() => ({
      context: this,
      generator: function* () {
        const ilmSession = yield this.args.session.ilmSession;
        const {
          learnerGroups,
          learners
        } = yield hash({
          learnerGroups: ilmSession.learnerGroups,
          learners: ilmSession.learners
        });
        this.learnerGroupBuffer = learnerGroups;
        this.learnerBuffer = learners;
        this.isManaging = true;
      }
    }), null, "manage", "drop"));
    _defineProperty(this, "save", _buildTask(() => ({
      context: this,
      generator: function* () {
        const ilmSession = yield this.args.session.ilmSession;
        ilmSession.set('learnerGroups', this.learnerGroupBuffer);
        ilmSession.set('learners', this.learnerBuffer);
        yield ilmSession.save();
        this.isManaging = false;
      }
    }), null, "save", "drop"));
  }
  get ilmSessionData() {
    return new TrackedAsyncData(this.args.session.ilmSession);
  }
  get courseData() {
    return new TrackedAsyncData(this.args.session.course);
  }
  get cohortsData() {
    return new TrackedAsyncData(this.course?.cohorts);
  }
  get ilmLearnersData() {
    return new TrackedAsyncData(this.ilmSession?.learners);
  }
  get ilmLearnerGroupsData() {
    return new TrackedAsyncData(this.ilmSession?.learnerGroups);
  }
  get ilmSession() {
    return this.ilmSessionData.isResolved ? this.ilmSessionData.value : null;
  }
  get course() {
    return this.courseData.isResolved ? this.courseData.value : null;
  }
  get cohorts() {
    return this.cohortsData.isResolved ? this.cohortsData.value : null;
  }
  get ilmLearners() {
    return this.ilmLearnersData.isResolved ? this.ilmLearnersData.value : null;
  }
  get ilmLearnerGroups() {
    return this.ilmLearnerGroupsData.isResolved ? this.ilmLearnerGroupsData.value : null;
  }
  get learnerCount() {
    if (!this.ilmSession) {
      return 0;
    }
    return this.ilmSession.learners.length;
  }
  get learnerGroupCount() {
    if (!this.ilmSession) {
      return 0;
    }
    return this.ilmSession.learnerGroups.length;
  }
  get selectedIlmLearners() {
    if (!this.ilmLearners) {
      return [];
    }
    return this.ilmLearners;
  }
  get selectedIlmLearnerGroups() {
    if (!this.ilmLearnerGroups) {
      return [];
    }
    return this.ilmLearnerGroups;
  }
  cancel() {
    this.learnerGroupBuffer = [];
    this.learnerBuffer = [];
    this.isManaging = false;
  }
  async addLearnerGroupToBuffer(learnerGroup, cascade) {
    if (cascade) {
      const descendants = await learnerGroup.getAllDescendants();
      this.learnerGroupBuffer = uniqueValues([...this.learnerGroupBuffer, ...descendants, learnerGroup]);
    } else {
      this.learnerGroupBuffer = uniqueValues([...this.learnerGroupBuffer, learnerGroup]);
    }
  }
  async removeLearnerGroupFromBuffer(learnerGroup, cascade) {
    let groupsToRemove = [learnerGroup];
    if (cascade) {
      const descendants = await learnerGroup.getAllDescendants();
      groupsToRemove = [...descendants, learnerGroup];
    }
    this.learnerGroupBuffer = uniqueValues(this.learnerGroupBuffer.filter(g => !groupsToRemove.includes(g)));
  }
  addLearnerToBuffer(learner) {
    this.learnerBuffer = [...this.learnerBuffer, learner];
  }
  removeLearnerFromBuffer(learner) {
    this.learnerBuffer = this.learnerBuffer.filter(obj => obj.id !== learner.id);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isManaging", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "learnerGroupBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "learnerBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "ilmSessionData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "ilmSessionData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cohortsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "cohortsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ilmLearnersData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "ilmLearnersData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ilmLearnerGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "ilmLearnerGroupsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addLearnerGroupToBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addLearnerGroupToBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeLearnerGroupFromBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeLearnerGroupFromBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addLearnerToBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addLearnerToBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeLearnerFromBuffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeLearnerFromBuffer"), _class.prototype), _class);
export { DetailLearnersAndLearnerGroupsComponent as default };